var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 441,
    viewBox: "0 0 496 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.25 336.775L31 336.495L25.2479 334.173C14.1339 329.685 5.71893 320.884 1.79703 309.645C0.101911 304.788 0 296.814 0 168.994C0 41.174 0.1021 33.2026 1.79703 28.3452C5.71893 17.1064 14.1339 8.3048 25.2479 3.81699C30.9964 1.49598 31.0355 1.4944 87.2502 1.20565L143.5 0.914062V8.92157V16.9291L87.7499 17.2133C26.1392 17.527 29.7312 17.1455 22.6779 24.0987C15.4532 31.2212 16.0295 21.1674 15.7331 145.245L15.4664 284.995H247.5H479.534L479.265 145.245C479.027 21.2287 479.53 31.1807 472.422 24.071C465.522 17.1715 468.869 17.5251 407.249 17.2133L351.499 16.9291V8.96217V0.993416H404.949C461.461 0.993416 465.017 1.2357 473.879 5.70121C479.815 8.6912 487.571 16.2564 490.412 21.8251C495.665 32.1213 495.499 27.3038 495.499 168.994C495.499 310.685 495.665 305.867 490.412 316.163C485.708 325.383 474.641 333.548 463.7 335.869C460.036 336.646 434.486 336.993 380.949 336.993L111.25 336.775ZM466.144 318.776C470.174 316.57 475.086 311.654 477.268 307.641C478.624 305.149 479.051 301.232 479.327 288.747L479.675 300.997H247.588H15.5001V286.754C15.5001 279.188 15.9377 302.036 16.4727 303.902C18.4272 310.717 24.5314 317.165 31.3364 319.605C34.3255 320.677 74.4071 320.881 249 320.709C449.307 320.512 463.201 320.387 466.144 318.776ZM175.683 231.247L176.001 201.497L178.955 196.165C184.464 186.219 192.248 181.602 203.501 181.604C215.251 181.608 222.918 186.39 228.798 197.381C230.903 201.315 231.014 202.82 231.318 231.247L231.635 260.997H223.568H215.501V248.997V236.998H203.501H191.501V248.997V260.997H183.434H175.368L175.683 231.247ZM215.5 213.402C215.5 204.93 214.029 201.331 209.46 198.632C203.911 195.355 196.491 197.358 193.136 203.038C192.008 204.946 191.5 208.165 191.5 213.402V220.998H203.5H215.5V213.402ZM239.5 224.545C239.5 199.582 239.856 187.31 240.63 185.613C242.513 181.479 245.966 180.782 262.677 181.169C275.186 181.46 278.643 181.863 281.5 183.374C290.472 188.118 294.924 195.289 294.929 204.997C294.933 214.557 290.551 221.776 282 226.294C278.804 227.983 275.739 228.488 266.75 228.81L255.5 229.214V245.105V260.997H247.5H239.5V224.545ZM277.046 210.543C278.593 208.996 279.5 206.946 279.5 204.997C279.5 203.049 278.593 200.999 277.046 199.452C274.783 197.189 273.847 196.997 265.046 196.997H255.5V204.997V212.998H265.046C273.847 212.998 274.783 212.805 277.046 210.543ZM303.5 220.998V180.997H311.5H319.5V220.998V260.997H311.5H303.5V220.998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.875 336.819L161.672 382.129L326.295 383.234L328.386 328.723",
    stroke: "black",
    strokeWidth: 11.3386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.51 383.023H132.728C122.244 383.023 113.746 391.521 113.746 402.004V415.971C113.746 426.454 122.244 434.951 132.728 434.951H355.51C365.993 434.951 374.492 426.454 374.492 415.971V402.004C374.492 391.521 365.993 383.023 355.51 383.023Z",
    stroke: "black",
    strokeWidth: 11.3386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 57H346",
    stroke: "black",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 111.5,
    r: 19.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 111.5,
    r: 19.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 111.5,
    r: 19.5,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 111.5,
    r: 19.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIntegrationIcon);
export default __webpack_public_path__ + "static/media/API_Integration_Icon.6db38ce460a026f6d9610309cf74d39d.svg";
export { ForwardRef as ReactComponent };